<h2 mat-dialog-title>
	@if (data.pickEmployee) {
		Ajouter un salarié — {{ data.scheduleName }}
	} @else {
		<!-- Le nom mène à SA fiche : vraie balise <a>, donc ctrl/shift+clic = nouvel onglet
		     (le dialogue reste ouvert ; seul le clic simple navigue et le referme). -->
		@if (data.id_employee) {
			<a class="sheet-link" [routerLink]="['/hr/employee', data.id_employee]" (click)="onSheetLink($event)"
				matTooltip="Ouvrir la fiche employé">{{ data.employeeName }}</a>
		} @else {
			{{ data.employeeName }}
		}
		— {{ data.dayLabel }}
	}
</h2>

<mat-dialog-content [formGroup]="form">

	@if (data.pickEmployee) {
		<div class="flexrow pick-row">
			<mat-form-field class="wide">
				<mat-label>Salarié</mat-label>
				<mat-select formControlName="id_employee">
					@for (e of data.employees ?? []; track e.id) {
						<mat-option [value]="e.id">{{ e.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<mat-form-field>
				<mat-label>Jour</mat-label>
				<mat-select formControlName="dat">
					@for (d of data.weekDays ?? []; track d.dat) {
						<mat-option [value]="d.dat">{{ d.label }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>
	} @else {
		<!-- Le planning = ce qui est réellement prévu ce jour. Réguliers et ajoutés côte à côte,
		     sans notion d'exception : un créneau ajouté fait partie du planning au même titre. -->
		<div class="day-plan">
			<div class="label">Ce qui est prévu ce jour</div>

			@if (dayOff) {
				<div class="flexrow plan-row off">
					<mat-icon class="off-icon">event_busy</mat-icon>
					<span>Ne travaille pas ce jour{{ dayOff.comment ? ' · ' + dayOff.comment : '' }}</span>
					<span class="spacer"></span>
					<button mat-icon-button type="button" matTooltip="Rétablir la journée" aria-label="Rétablir la journée" (click)="onDeleteOverride(dayOff)">
						<mat-icon>undo</mat-icon>
					</button>
				</div>
			}

			<!-- Chaque ligne dit OÙ : sur une même journée le matin peut être à Ollioules et
			     l'après-midi à La Seyne. Sans le lieu, « 09:00–12:00 » ne renseigne qu'à moitié. -->
			@for (s of regularSlots; track $index) {
				<div class="flexrow plan-row">
					<span class="hrs">{{ slotLabel(s) }}</span>
					@if (s.place) {
						<span class="place"><mat-icon>storefront</mat-icon>{{ s.place }}</span>
					}
					<span class="spacer"></span>
					<span class="tag" matTooltip="Vient des horaires réguliers de ce salarié">régulier</span>
				</div>
			}

			@for (o of addedSlots; track o.id) {
				<div class="flexrow plan-row">
					<span class="hrs">{{ addedLabel(o) }}</span>
					@if (placeOf(o.id_schedule); as place) {
						<span class="place"><mat-icon>storefront</mat-icon>{{ place }}</span>
					}
					<span class="spacer"></span>
					<button mat-icon-button type="button" matTooltip="Retirer ce créneau" aria-label="Retirer ce créneau" (click)="onDeleteOverride(o)">
						<mat-icon>close</mat-icon>
					</button>
				</div>
			}

			@if (!hasAnySlot && !dayOff) {
				<div class="empty">Rien de prévu — ajoutez un créneau ci-dessous.</div>
			}
		</div>
	}

	<div class="add-block">
		<div class="label">Ajouter un créneau</div>
		<div class="flexrow add-row">
			<mat-form-field class="time">
				<mat-label>Début</mat-label>
				<input matInput type="time" formControlName="start">
			</mat-form-field>
			<span class="dash">–</span>
			<mat-form-field class="time">
				<mat-label>Fin</mat-label>
				<input matInput type="time" formControlName="end">
			</mat-form-field>
		</div>
		<!-- OÙ ce créneau se tient : établissement × service. Le choix n'était pas offert, l'ajout
		     partait donc en silence sur le premier emploi du temps du magasin affiché — une personne
		     mobile se retrouvait planifiée au mauvais endroit sans que rien ne le dise. -->
		<mat-form-field class="full">
			<mat-label>Où travaille-t-elle&nbsp;?</mat-label>
			<mat-select formControlName="id_schedule">
				@for (p of places; track p.id_schedule) {
					<mat-option [value]="p.id_schedule">{{ p.label }}</mat-option>
				}
			</mat-select>
			@if (places.length > 1) {
				<mat-hint>Établissement et service — cette personne peut travailler à plusieurs endroits</mat-hint>
			} @else {
				<mat-hint>Établissement et service sur lesquels ce créneau sera posé</mat-hint>
			}
		</mat-form-field>
		<mat-form-field class="full">
			<mat-label>Précision (facultatif)</mat-label>
			<input matInput formControlName="comment" placeholder="ex. remplace Marie, renfort inventaire">
		</mat-form-field>
	</div>

	@if (errorMessage) {
		<div class="error">{{ errorMessage }}</div>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="onCancel()">Fermer</button>
	@if (!data.pickEmployee && hasAnySlot) {
		<button mat-stroked-button color="warn" type="button" (click)="onRemoveDay()">
			<mat-icon>event_busy</mat-icon>&nbsp;Ne travaille pas ce jour
		</button>
	}
	<button mat-flat-button color="primary" type="button" (click)="onAdd()">
		<mat-icon>add</mat-icon>&nbsp;Ajouter le créneau
	</button>
</mat-dialog-actions>
